"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT_VARIANTS = exports.TEXT_VARIANT_NAMES = exports.TEXT_FONTS = void 0;
/** Available fonts */
exports.TEXT_FONTS = {
    sans: '"ll-unica77", "Helvetica Neue", Helvetica, Arial, sans-serif'
};
/** Available text variant names */
exports.TEXT_VARIANT_NAMES = [
    "xxl",
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
/** Available text variants */
exports.TEXT_VARIANTS = {
    xxl: {
        fontSize: "50px",
        lineHeight: "54px",
        letterSpacing: "-0.02em"
    },
    xl: {
        fontSize: "34px",
        lineHeight: "38px",
        letterSpacing: "-0.02em"
    },
    lg: {
        fontSize: "24px",
        lineHeight: "28px",
        letterSpacing: "-0.02em"
    },
    md: {
        fontSize: "16px",
        lineHeight: "20px"
    },
    sm: {
        fontSize: "16px",
        lineHeight: "24px"
    },
    xs: {
        fontSize: "13px",
        lineHeight: "18px"
    }
};
